
import {Component, ChangeDetectionStrategy, input, computed} from "@angular/core";
import {EnvDescriptor} from "app/Environment/EnvLoader";

@Component({
    imports: [],
    selector: "small-badge",
    template: `
    <div class="w-full h-full rounded gap-2 font-semibold px-1 text-white flex items-center"
      style="background: {{this.effectiveBackground()}}; color: {{this.effectiveForeground()}};">
      @if (this.iconUrl()) {
        <img [attr.src]="this.computeIconUrl()"
          class="h-full aspect-square rounded-full bg-white object-cover">
      }
      <p class="my-0" [innerText]="this.label()"></p>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./SmallBadge.component.scss"]
})
export class SmallBadgeComponent {

  readonly label = input<string>("Label");

  readonly backgroundColor = input<string>("#FF0000");
  readonly foregroundColor = input<string>("#FFFFFF");

  protected readonly effectiveBackground = computed(() => this.backgroundColor() || "#333");
  /** Couleur de texte lisible calculée depuis la couleur de fond (ignore foregroundColor, comme avant) */
  protected readonly effectiveForeground = computed(() => this.getReadableTextColorForBackground(this.backgroundColor()));

  readonly iconUrl = input<string>();

  getReadableTextColorForBackground(bgColor: string): string {
    const hex = bgColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return brightness > 180 ? '#000000' : '#FFFFFF';
  }

  computeIconUrl(): string | undefined {
    const iconUrl = this.iconUrl();
    if (!iconUrl) {
      return undefined;
    }

    const env = (globalThis as any).env as EnvDescriptor;
    if (!env) return undefined;


    return `${env.qdmApiUrl}/${iconUrl}`;
  }

}
